// 全局错误处理工具
import { debugError, debugWarn, IS_DEV } from './env'

// 处理未捕获的Promise rejection
export function setupGlobalErrorHandlers() {
  // 处理未捕获的Promise rejection
  window.addEventListener('unhandledrejection', (event) => {
    debugError('未处理的Promise rejection:', event.reason)
    
    // 防止错误在控制台显示为未处理的Promise rejection
    event.preventDefault()
    
    // 可以在这里添加错误上报逻辑
    if (IS_DEV) {
      debugWarn('开发环境：Promise rejection已被捕获和处理')
    }
  })

  // 处理未捕获的JavaScript错误
  window.addEventListener('error', (event) => {
    debugError('未捕获的JavaScript错误:', event.error)
    
    if (IS_DEV) {
      debugWarn('开发环境：JavaScript错误已被捕获')
    }
  })
}

// 安全的Promise包装器
export function safePromise<T>(promise: Promise<T>): Promise<[T | null, Error | null]> {
  return promise
    .then<[T, null]>((data: T) => [data, null])
    .catch<[null, Error]>((error: Error) => [null, error])
}

// 安全的异步函数执行
export async function safeAsync<T>(
  asyncFn: () => Promise<T>,
  fallback?: T
): Promise<{ data: T | null; error: Error | null }> {
  try {
    const data = await asyncFn()
    return { data, error: null }
  } catch (error) {
    debugError('异步执行错误:', error)
    return { data: fallback || null, error: error as Error }
  }
}